import { render, staticRenderFns } from "./Scan.vue?vue&type=template&id=271ecd4c&scoped=true&"
import script from "./Scan.vue?vue&type=script&lang=js&"
export * from "./Scan.vue?vue&type=script&lang=js&"
import style0 from "./Scan.vue?vue&type=style&index=0&id=271ecd4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ecd4c",
  null
  
)

export default component.exports